// The palette repeats every 21 rows, and index 0 is reserved for a trait-coloured row. Chart and table
// read a row's colour through this, so one row is one colour in both, whatever the question type.
export const COLOR_INDEXES = 21

export const colorIndexOf = position => ((position - 1) % COLOR_INDEXES) + 1
